




import { Component, Vue } from 'vue-property-decorator';
import ProductList from '@/pages/Product/ProductList.vue';

@Component({
  components: {
    ProductList,
  },
})
export default class Products extends Vue {}
